import React from "react";
import ImageLoader from "./ImageUploader";
import ImgLabel from "@component/assure/ImgLabel";
import INavBar from "@component/INavBar";
import './index.scss'
import {Button, Toast} from "antd-mobile";
import {getQueryParams, isEmpty} from "@src/util";
import CommonService from "@service/commonService";
import {goBack} from "@src/route";
import AsyncImg from "@component/assure/AsyncImg";


type ArchiveEditStateType = {
	form: any
}

export default class ArchiveEdit extends React.Component<any, ArchiveEditStateType> {

	id: number

	constructor(props: any) {
		super(props);

		const queryParams = getQueryParams()
		this.id = parseInt(queryParams.id);
		this.state = {
			form: {}
		}
	}

	getDetail() {
		CommonService.getArchiveDetail(this.id).then(rs => {
			const form = {
				...this.state.form,
				...rs
			}
			this.setState({form})
		})
	}


	componentDidMount() {
		this.getDetail()
	}


	render() {
		const {form} = this.state;

		const di = form.driveImgOssKeys || []
		const df = di[0]
		const db = di[1]

		const otherImages = form.addImgOssKeys || []
		const olist: Array<any> = otherImages.length < 15 ? otherImages.concat([undefined]) : otherImages

		return <div className="archive">
			<INavBar title={`资料归档`}/>
			<div className="archive-form">
				<div className="archive-info">
					{
						form.checkComment == 4 && <div>驳回原因：{form.checkComment}</div>
					}

					<div className="item">客户姓名:{form.insuredName}</div>
					<div className="item">手机号码:{form.mobile}</div>
				</div>
				<div className="archive-form-title1">归档要件：</div>
				{/* <div className="archive-form-title required">客户与车的合影（不能带口罩）</div>
				<div className="archive-form-img-box">
					<AsyncImg contain="true"
							  src={form.cusvehicleimgOssKey?.osskeySmall}
							  showsrc={form.cusvehicleimgOssKey?.osskey || form.cusvehicleimgOssKey?.osskeySmall}/>
				</div> */}
				{/* <div className="archive-form-title required">车架号照片</div>
				<div className="archive-form-img-box">
					<AsyncImg contain="true"
							  src={form.vehiclevinimgOssKey?.osskeySmall}
							  showsrc={form.vehiclevinimgOssKey?.osskey || form.vehiclevinimgOssKey?.osskeySmall}/>

				</div> */}
				{/* <div className="archive-form-title required">仪表盘照片</div>
				<div className="archive-form-img-box">
					<AsyncImg contain="true"
							  src={form.vehicledashboardimgOssKey?.osskeySmall}
							  showsrc={form.vehicledashboardimgOssKey?.osskey || form.vehicledashboardimgOssKey?.osskeySmall}/>
				</div> */}
				{/* <div className="archive-form-title required">整车照片</div>
				<div className="archive-form-img-box">
					<AsyncImg contain="true"
							  src={form.vehicleimgOssKey?.osskeySmall}
							  showsrc={form.vehicleimgOssKey?.osskey || form.vehicleimgOssKey?.osskeySmall}/>
				</div> */}
				<div className="archive-form-title required">行驶证正反面</div>
				<div className="archive-form-img-box">
					{
						form.driveImgOssKeys?.map((d: any, i: number) =>
							<AsyncImg contain="true"
									  key={i}
									  src={d?.osskeySmall}
									  showsrc={d?.osskey || d?.osskeySmall}/>
						)
					}
				</div>
				<div className="archive-form-title required">摩托车登记证照片</div>
				<div className="archive-form-img-box">
					<AsyncImg contain="true"
							  src={form.vehicleRegisterImgOssKeys?.osskeySmall}
							  showsrc={form.vehicleRegisterImgOssKeys?.osskey || form.vehicleRegisterImgOssKeys?.osskeySmall}/>
				</div>
				<div className="archive-form-title">解除抵押凭证</div>
				<div className="archive-form-img-box">
					<AsyncImg contain="true"
							  src={form.releasedMortgageImgOssKeys?.osskeySmall}
							  showsrc={form.releasedMortgageImgOssKeys?.osskey || form.releasedMortgageImgOssKeys?.osskeySmall}/>
				</div>
				{/* <div className="archive-form-title">购置税发票</div>
				<div className="archive-form-img-box">
					<AsyncImg contain="true"
							  src={form.invoiceImgOssKey?.osskeySmall}
							  showsrc={form.invoiceImgOssKey?.osskey || form.invoiceImgOssKey?.osskeySmall}/>
				</div> */}
				<div className="archive-form-title">其他</div>
				<div className="archive-form-img-box">
					{
						form.otherimgOssKeys?.map((d: any, i: number) =>
							<AsyncImg contain="true"
									  key={i}
									  src={d?.osskeySmall}
									  showsrc={d?.osskey || d?.osskeySmall}/>
						)
					}
				</div>
			</div>
		</div>;
	}
}